import axios from 'axios';
import { API_URL, getAuthHeader } from '.';
import { ResponseModel } from '../Models/ResponseModel';
import { Manufacturer } from '../Models/Manufacturer';
import { SubCategory } from '../Models/SubCategory';
import { Category } from '../Models/Category';

class ManufacturerApi {
  static getManufacturer(id: string) {
    return axios.get<Manufacturer>(
      `${API_URL}/api/manufacturer/${id}`,
      getAuthHeader()
    );
  }
  static getManufacturerCategories(id: string) {
    return axios.get<Category[]>(
      `${API_URL}/api/manufacturer/${id}/categories`,
      getAuthHeader()
    );
  }
  static getManufacturerSubCategories(id: string) {
    return axios.get<SubCategory[]>(
      `${API_URL}/api/manufacturer/${id}/subcategories`,
      getAuthHeader()
    );
  }
  static addUpdateManufacturer(request: Manufacturer) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/manufacturer`,
      request,
      getAuthHeader()
    );
  }
  static deleteManufacturer(id: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/manufacturer/${id}`,
      getAuthHeader()
    );
  }
  static getManufacturerList() {
    return axios.get<Manufacturer[]>(`${API_URL}/api/manufacturer`);
  }
  static getManufacturerListWG() {
    return axios.get<Manufacturer[]>(`${API_URL}/api/manufacturer/WG`);
  }
  static uploadManufacturerImage(request: FormData) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/manufacturer/imageupload`,
      request,
      getAuthHeader()
    );
  }
}

export default ManufacturerApi;
